(function () {
  'use strict';
  const configNode = document.getElementById('gnm-series1-pricing-config');
  if (!configNode || window.GNMSeries1Pricing) return;
  const config = JSON.parse(configNode.textContent);
  const key = 'series-1-us-49-vs-59-matched-savings';
  const project = 'phc_pbTRMJSewe42HtkUSAJBAEMCBgYYjAy8QsgKSrikmjAn';
  const original = ['51470249230517', '51470436827317'];
  const usOriginal = [...original, '51577635799221', '51585253474485', '51634584420533'];
  const usMarket = config.country === 'US' && config.currency === 'USD';
  const bulkOffer = '53585263165621';
  const eligibleOriginal = usMarket ? usOriginal : original;
  const usOffer = '53571086188725';
  const series2Original = '51488053952693';
  const series2Offer = '53603479290037';
  const series2Code = 'SERIES2SAVE106';
  const internationalOffer = '53573788172469';
  const allOffers = [usOffer, internationalOffer];
  const markets = {"CA":{"currency":"CAD","price":9700,"reference":16499,"code":"SERIES1-CA-SAVINGS"},"GB":{"currency":"GBP","price":4900,"reference":13000,"code":"SERIES1-GB-SAVINGS"},"AU":{"currency":"AUD","price":9700,"reference":25499,"code":"SERIES1-AU-SAVINGS"},"SG":{"currency":"SGD","price":9700,"reference":27500,"code":"SERIES1-SG-SAVINGS"},"IE":{"currency":"EUR","price":7900,"reference":14500,"code":"SERIES1-IE-SAVINGS"},"NZ":{"currency":"NZD","price":14900,"reference":27500,"code":"SERIES1-NZ-SAVINGS"}};
  const international = markets[config.country]?.currency === config.currency ? markets[config.country] : null;
  const offer = international ? internationalOffer : usOffer;
  const offerSelector = 'a[href*="with-jesus-series-1-us-price-test-draft"],a[href*="with-jesus-series-1-bundle-11-books-international"]';
  const discountCodes = {control:'SERIES1SAVE106','us-49':'SERIES1SAVE116'};
  let discountCode = discountCodes.control;
  let eligibleUS = false;
  const root = config.root;
  const html = document.documentElement;
  let settle;
  let complete = false;
  let sdk;
  let cartQueue = Promise.resolve();
  const ready = new Promise(resolve => { settle = resolve; });
  const api = window.GNMSeries1Pricing = {
    ready, treatment: false, discounted: false, singlePrice: 5900, referencePrice: 16500, discountCode, variant: 'inactive',
    singleVariant(id, quantity) {
      if ([series2Original, series2Offer].includes(String(id))) return Number(usMarket && Number(quantity) === 1 ? series2Offer : series2Original);
      if (usMarket && eligibleOriginal.includes(String(id)) && [3, 5].includes(Number(quantity))) return Number(bulkOffer);
      return api.discounted && Number(quantity) === 1 && eligibleOriginal.includes(String(id)) ? Number(offer) : Number(id);
    },
    cartLink(id, quantity) {
      const selected = api.singleVariant(id, quantity);
      return root + 'cart/' + selected + ':' + quantity + (String(selected) === series2Offer ? '?discount=' + series2Code : String(selected) === offer ? '?discount=' + discountCode : '');
    },
    adjustDisplay(result, id, quantity) {
      if (usMarket && eligibleOriginal.includes(String(id)) && [3, 5].includes(Number(quantity))) return Object.assign({}, result, {price: Number(quantity) === 3 ? 11800 : 17700, compareAtPrice: 16500 * Number(quantity)});
      return api.discounted && Number(quantity) === 1 && eligibleOriginal.includes(String(id))
        ? Object.assign({}, result, {price: api.singlePrice, compareAtPrice: api.referencePrice}) : result;
    },
    async mapItems(items) {
      await ready;
      return items.map(item => {
        const id = api.singleVariant(item.id, item.quantity || 1);
        return id === Number(offer) ? Object.assign({}, item, {id, properties: Object.assign({}, item.properties, international ? {_gnm_checkout_savings: config.country} : {_gnm_price_test: key, _gnm_price_variant: api.variant})}) : Object.assign({}, item, {id});
      });
    },
    async prepareFormData(data) {
      await ready;
      if (!api.discounted) return data;
      const fields = Array.from(data.keys());
      const itemKeys = fields.filter(name => /^items\[\d+\]\[id\]$/.test(name));
      for (const name of itemKeys.length ? itemKeys : ['id']) {
        const prefix = name === 'id' ? '' : name.slice(0, -4);
        const quantityName = prefix ? prefix + '[quantity]' : 'quantity';
        const quantity = Number(data.get(quantityName) || 1);
        const mapped = api.singleVariant(data.get(name), quantity);
        if (data.get(prefix ? prefix + '[selling_plan]' : 'selling_plan')) continue;
        if ([Number(series2Original), Number(series2Offer)].includes(mapped)) { data.set(name, String(mapped)); continue; }
        if (mapped === Number(bulkOffer)) { data.set(name, String(mapped)); continue; }
        if (mapped !== Number(offer)) continue;
        data.set(name, String(mapped));
        if (international) {
          data.set(prefix ? prefix + '[properties][_gnm_checkout_savings]' : 'properties[_gnm_checkout_savings]', config.country);
        } else {
          data.set(prefix ? prefix + '[properties][_gnm_price_test]' : 'properties[_gnm_price_test]', key);
          data.set(prefix ? prefix + '[properties][_gnm_price_variant]' : 'properties[_gnm_price_variant]', api.variant);
        }
      }
      return data;
    },
    reconcileCart(sections) {
      if (!international && !api.discounted && !config.hasOffer && !document.querySelector(offerSelector)) return Promise.resolve(null);
      const next = cartQueue.catch(() => {}).then(() => reconcile(sections));
      cartQueue = next;
      return next;
    }
  };
  function finish(variant, reason) {
    if (complete) return;
    complete = true;
    api.variant = variant;
    api.treatment = variant === 'us-49';
    api.discounted = ['control','us-49','international'].includes(variant);
    api.singlePrice = international ? international.price : api.treatment ? 4900 : 5900;
    api.referencePrice = international ? international.reference : 16500;
    discountCode = international ? international.code : api.treatment ? discountCodes['us-49'] : discountCodes.control;
    api.discountCode = discountCode;
    html.dataset.gnmPriceVariant = variant;
    html.dataset.gnmPriceStatus = reason;
    try {
      applyContent();
      document.dispatchEvent(new CustomEvent('gnm:pricing-ready', {detail: {variant}}));
    } finally {
      settle(api);
    }
    if (sdk && config.kind !== 'index' && reason === 'assigned' && ['control', 'us-49'].includes(variant)) {
      sdk.getFeatureFlag(key);
      sdk.capture('gnm_series1_price_exposure', {experiment_key:key, variant, page_kind:config.kind, page_path:location.pathname, market:config.country, currency:config.currency});
    }
  }
  function textReplace(element, pattern, replacement) {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement?.closest('script,style,svg')) continue;
      node.nodeValue = node.nodeValue.replace(pattern, replacement);
    }
  }
  function money(value) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:config.currency,minimumFractionDigits:value % 100 ? 2 : 0,maximumFractionDigits:2}).format(value/100);
  }
  function noteAfter(element) {
    if (!element || element.nextElementSibling?.classList.contains('gnm-price-checkout-note')) return;
    const p = document.createElement('p');
    p.className = 'gnm-price-checkout-note';
    p.textContent = international ? config.internationalNote.replace('__SAVINGS__', money(api.referencePrice-api.singlePrice)).replace('__CODE__',discountCode) : api.treatment ? config.note : config.controlNote;
    element.after(p);
  }
  function applyContent() {
    if (usMarket) document.querySelectorAll('a[href*="/cart/"]').forEach(a => {
      const url = new URL(a.href, location.origin);
      if (!url.pathname.endsWith('/cart/' + series2Original + ':1')) return;
      url.pathname = url.pathname.replace(series2Original + ':1', series2Offer + ':1');
      url.searchParams.set('discount', series2Code);
      a.href = url.href;
    });
    if (!api.discounted || !config.eligible) return;
    if (config.kind === 'index') {
      document.querySelectorAll('.product-card').forEach(card => {
        const series1 = Array.from(card.querySelectorAll('a[href]')).some(link =>
          /\/products\/(with-jesus-series-bundle-11-books|with-jesus-series-bundle-11-books-exclusive-discount)\/?$/.test(new URL(link.href, location.origin).pathname)
        );
        if (!series1) return;
        const price = card.querySelector('.collection-current-price');
        const reference = card.querySelector('.collection-regular-price');
        const badge = card.querySelector('.sale-badge');
        if (price) price.textContent = money(api.singlePrice);
        if (reference) reference.textContent = money(api.referencePrice);
        if (badge) textReplace(badge, /(?:US\$|\$)106(?:\.00)?(?![\d.])/g, money(api.referencePrice - api.singlePrice));
      });
      return;
    }
    const christmas = document.getElementById('gnm-angle-original');
    if (!christmas) {
      document.querySelectorAll('[class*="gnm_kids_book_bundle"][class$="-sale-price"]').forEach(e => {e.textContent = money(api.singlePrice);});
      document.querySelectorAll('[class*="gnm_kids_book_bundle"][class$="-original-price"]').forEach(e => {e.textContent = money(api.referencePrice);});
      document.querySelectorAll('[class*="gnm_kids_book_bundle"][class$="-savings-text"]').forEach(e => {e.textContent = international ? config.internationalSavings.replace('__SAVINGS__',money(api.referencePrice-api.singlePrice)) : api.treatment ? config.savings : config.controlSavings;});
      document.querySelectorAll('[class*="gnm_kids_book_bundle"][class$="-per-item-price"]').forEach(e => {e.textContent = money(Math.round(api.singlePrice/11)) + ' per book';});
    }
    document.querySelectorAll('a[href*="/cart/"]').forEach(a => {
      if (a.hasAttribute('aria-disabled')) return;
      const url = new URL(a.href, location.origin);
      const match = url.pathname.match(/\/cart\/(51470249230517|51470436827317|51577635799221|51585253474485|51634584420533):(1|3|5)$/);
      if (!match) return;
      if (match[2] !== '1') { if (usMarket) { url.pathname = url.pathname.replace(match[1] + ':' + match[2], bulkOffer + ':' + match[2]); a.href = url.href; } return; }
      a.dataset.gnmOriginalVariant = match[1];
      url.pathname = url.pathname.replace(match[1] + ':1', offer + ':1');
      url.searchParams.set('discount', discountCode);
      a.href = url.href;
      if (!international) textReplace(a, /(?:US\$|\$)(?:49|59|69)(?:\.00)?(?![\d.])/g, '$' + api.singlePrice / 100);
      if (!a.hasAttribute('data-gift-quantity')) {
        a.addEventListener('click', async event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (a.getAttribute('aria-disabled') === 'true') return;
          a.setAttribute('aria-disabled', 'true');
          try {
            await request('cart/add.js', {items: await api.mapItems([{id:Number(a.dataset.gnmOriginalVariant), quantity:1}])});
            await api.reconcileCart();
            const target = new URL(root + 'checkout', location.origin);
            for (const name of ['sqdid','click_id','fbclid','gclid','ttclid','utm_source','utm_medium','utm_campaign','utm_content','utm_term']) {
              const value = new URL(location.href).searchParams.get(name);
              if (value) target.searchParams.set(name, value);
            }
            location.assign(target.href);
          } catch (error) {
            a.removeAttribute('aria-disabled');
            let status = a.parentElement.querySelector('.gnm-price-error');
            if (!status) {status = document.createElement('p');status.className = 'gnm-price-error';status.setAttribute('role','alert');a.after(status);}
            status.textContent = config.error;
          }
        });
      }
    });
    if (!international) document.querySelectorAll('.gc-quick-tip,.gl-price,.gl-per-book,[class*="gnm_kids_hero"][class*="description-block"]').forEach(e => {
      textReplace(e, /\$(?:49|59|69)(?:\.00)?(?![\d.])/g, '$' + api.singlePrice / 100);
      textReplace(e, /\$(?:4\.45|5\.36)/g, money(Math.round(api.singlePrice / 11)));
    });
    document.querySelectorAll('[class*="gnm_kids_book_bundle"][class$="-price-row"],.shop-product-price-container,.gc-quick-tip,.gl-price').forEach(noteAfter);
  }
  async function request(path, body) {
    const response = await fetch(root + path, body ? {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)} : {headers:{'Accept':'application/json'}});
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || config.error);
    return data;
  }
  async function reconcile(sections) {
    let cart = await request('cart.js');
    cart = await reconcileSeries2(cart, sections);
    if (usMarket && cart.currency === 'USD') {
      const lines = cart.items.filter(item => usOriginal.includes(String(item.variant_id)) || String(item.variant_id) === usOffer || String(item.variant_id) === bulkOffer);
      const total = lines.reduce((sum, item) => sum + item.quantity, 0);
      const target = [3, 5].includes(total) ? bulkOffer : total === 1 ? usOffer : null;
      const moveLines = target ? lines.filter(item => String(item.variant_id) !== target && !item.selling_plan_allocation) : [];
      if (moveLines.length) {
        const quantity = moveLines.reduce((sum, item) => sum + item.quantity, 0);
        const properties = target === usOffer ? {_gnm_price_test:key, _gnm_price_variant:api.variant} : {};
        const added = await request('cart/add.js', {items:[{id:Number(target), quantity, properties}]});
        try { cart = await request('cart/update.js', {updates:Object.fromEntries(moveLines.map(item => [item.key,0])), sections:sections || ['cart-drawer','cart-icon-bubble','main-cart-items','main-cart-footer'], sections_url:location.pathname}); }
        catch(error) { const rollback={}; for (const item of added.items || []) rollback[item.key]=Math.max(0,item.quantity-quantity); if(Object.keys(rollback).length) await request('cart/update.js',{updates:rollback}); throw error; }
      }
      return await syncDiscount(cart, sections) || cart;
    }
    const series1Lines = cart.items.filter(item => original.includes(String(item.variant_id)) || allOffers.includes(String(item.variant_id)));
    const originalSingle = series1Lines.length === 1 && series1Lines[0].quantity === 1 && original.includes(String(series1Lines[0].variant_id)) ? series1Lines[0] : null;
    if (international && cart.currency === international.currency && originalSingle && !originalSingle.selling_plan_allocation) {
      const properties = Object.assign({}, originalSingle.properties, {_gnm_checkout_savings:config.country});
      delete properties._gnm_price_test;
      delete properties._gnm_price_variant;
      const added = await request('cart/add.js', {items:[{id:Number(internationalOffer),quantity:1,properties}]});
      try {
        cart = await request('cart/update.js', {updates:{[originalSingle.key]:0},sections:sections || ['cart-drawer','cart-icon-bubble','main-cart-items','main-cart-footer'],sections_url:location.pathname});
      } catch (error) {
        const rollback = {};
        for (const item of added.items || []) rollback[item.key] = Math.max(0,item.quantity-1);
        if (Object.keys(rollback).length) await request('cart/update.js',{updates:rollback});
        throw error;
      }
      return await syncDiscount(cart,sections) || cart;
    }
    const offerLines = cart.items.filter(item => allOffers.includes(String(item.variant_id)));
    if (!offerLines.length) return syncDiscount(cart, sections);
    const quantity = offerLines.reduce((sum, item) => sum + item.quantity, 0);
    const marketSupported = international ? cart.currency === international.currency : config.country === 'US' && cart.currency === 'USD';
    const existing = cart.items.filter(item => original.includes(String(item.variant_id))).reduce((sum,item) => sum + item.quantity, 0);
    const combined = quantity + existing;
    const grouped = combined >= 5 ? combined - (combined % 5 === 1 || combined % 5 === 2 ? combined % 5 : 0) : combined >= 3 ? 3 : 0;
    const wrongMarket = offerLines.filter(item => String(item.variant_id) !== offer).reduce((sum,item)=>sum+item.quantity,0);
    const move = marketSupported ? Math.max(wrongMarket, Math.max(0, Math.min(quantity, grouped - existing))) : quantity;
    if (!move) return syncDiscount(cart, sections);
    let remaining = quantity - move;
    const updates = {};
    offerLines.forEach(item => {const keep = String(item.variant_id) === offer ? Math.min(remaining,item.quantity) : 0; updates[item.key]=keep; remaining -= keep;});
    const retainedProperties = Object.assign({}, offerLines[0].properties);
    delete retainedProperties._gnm_price_test;
    delete retainedProperties._gnm_price_variant;
    delete retainedProperties._gnm_checkout_savings;
    const added = await request('cart/add.js', {items:[{id:51470436827317,quantity:move,properties:retainedProperties}]});
    try {cart = await request('cart/update.js', {updates,sections:sections || ['cart-drawer','cart-icon-bubble','main-cart-items','main-cart-footer'],sections_url:location.pathname});}
    catch (error) {
      const rollback = {};
      for (const item of added.items || []) rollback[item.key] = Math.max(0, item.quantity - move);
      if (Object.keys(rollback).length) await request('cart/update.js',{updates:rollback});
      throw error;
    }
    if (international && combined === 1 && wrongMarket === 1) return reconcile(sections);
    return await syncDiscount(cart, sections) || cart;
  }
  async function reconcileSeries2(cart, sections) {
    const lines = cart.items.filter(item => [series2Original, series2Offer].includes(String(item.variant_id)) && !item.selling_plan_allocation);
    const quantity = lines.reduce((sum, item) => sum + item.quantity, 0);
    const target = usMarket && cart.currency === 'USD' && quantity === 1 ? series2Offer : series2Original;
    const move = lines.filter(item => String(item.variant_id) !== target);
    if (!move.length) return cart;
    const movedQuantity = move.reduce((sum, item) => sum + item.quantity, 0);
    const properties = Object.assign({}, move[0].properties);
    const added = await request('cart/add.js', {items:[{id:Number(target),quantity:movedQuantity,properties}]});
    try {
      return await request('cart/update.js', {updates:Object.fromEntries(move.map(item => [item.key,0])),sections:sections || ['cart-drawer','cart-icon-bubble','main-cart-items','main-cart-footer'],sections_url:location.pathname});
    } catch(error) {
      const rollback = {};
      for (const item of added.items || []) rollback[item.key] = Math.max(0,item.quantity-movedQuantity);
      if (Object.keys(rollback).length) await request('cart/update.js',{updates:rollback});
      throw error;
    }
  }
  async function syncDiscount(cart, sections) {
    const offerLines = cart.items.filter(item => String(item.variant_id) === offer);
    const applicable = (international ? cart.currency === international.currency : config.country === 'US' && cart.currency === 'USD') && offerLines.length > 0;
    const codes = (cart.discount_codes || []).map(item => item.code).filter(Boolean);
    const hasControl = offerLines.some(item => item.properties?._gnm_price_variant === 'control');
    const hasTreatment = offerLines.some(item => item.properties?._gnm_price_variant === 'us-49');
    const legacyTreatment = !hasControl && codes.some(code => code.toUpperCase() === discountCodes['us-49']);
    const desiredCode = international ? international.code : api.discounted ? discountCode : (hasTreatment || legacyTreatment ? discountCodes['us-49'] : discountCodes.control);
    const ownCodes = [series2Code,...Object.values(discountCodes),...Object.values(markets).map(m=>m.code)];
    const retained = codes.filter(code => !ownCodes.includes(code.toUpperCase()));
    if (applicable) retained.push(desiredCode);
    if (usMarket && cart.currency === 'USD' && cart.items.some(item => String(item.variant_id) === series2Offer)) retained.push(series2Code);
    const normalize = values => values.map(code => code.toUpperCase()).sort().join(',');
    if (normalize(codes) === normalize(retained)) return null;
    return request('cart/update.js', {discount:retained.join(','),sections:sections || ['cart-drawer','cart-icon-bubble','main-cart-items','main-cart-footer'],sections_url:location.pathname});
  }
  document.addEventListener('DOMContentLoaded', applyContent);
  function refreshExistingCart() {
    if ((!international && !usMarket) || config.kind !== 'cart' || !config.hasOriginalSingle) return;
    api.reconcileCart().then(cart => {if (cart) location.reload();}).catch(() => {
      const p=document.createElement('p');p.setAttribute('role','alert');p.textContent=config.error;
      const target=document.querySelector('main');if(target)target.prepend(p);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',refreshExistingCart,{once:true});
  else refreshExistingCart();
  document.addEventListener('click', event => {
    const element = event.target.closest('a[href*="/checkout"],button[name="checkout"],input[name="checkout"]');
    if (!element || (!usMarket && !international && !document.querySelector(allOffers.map(id=>'[data-variant-id="'+id+'"]').join(',')+','+offerSelector))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    api.reconcileCart().then(() => location.assign(root + 'checkout')).catch(() => {
      const p=document.createElement('p');p.setAttribute('role','alert');p.textContent=config.error;element.after(p);
    });
  }, true);
  if (international) {
    finish('international','localized-checkout-savings');
    return;
  }
  finish(usMarket ? 'control' : 'inactive', usMarket ? 'merchant-59-rollout' : 'excluded-market');
})();


